var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedAnnualConsumption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA700",
    fillOpacity: 0.2,
    d: "M0 0h36v36H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#led-annual-consumption_svg__clip0)",
    fill: "#FFA700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.422 16.042a.39.39 0 00.402-.192l2.343-4.102a.39.39 0 00-.339-.584h-1.433l-.527-2.845a.39.39 0 00-.727-.114l-2.344 4.336a.39.39 0 00.344.576h1.437l.523 2.616a.39.39 0 00.32.309zm-.524-3.706h-1.102l1.506-2.786.384 2.076a.39.39 0 00.384.32h1.085l-1.492 2.61-.382-1.906a.39.39 0 00-.383-.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 25.93a.39.39 0 000 .782h.9v.898a.39.39 0 00.78 0v-.898h1.68v.898a.39.39 0 00.781 0v-.898h1.563v.898a.39.39 0 00.781 0v-.898h1.563v.898a.39.39 0 00.78 0v-.898h1.563v.898a.39.39 0 00.782 0v-.898h1.562v.898a.39.39 0 00.781 0v-.898h1.563v.898a.39.39 0 00.781 0v-.898h1.563v.898a.39.39 0 00.78 0v-.898h1.016a.39.39 0 000-.781h-2.187v-2.657a.39.39 0 10-.781 0v2.657h-1.563V17.22h1.563v2.539a.39.39 0 00.78 0v-2.93a.39.39 0 00-.39-.39h-2.343a.39.39 0 00-.391.39v9.102h-1.563v-6.758a.39.39 0 00-.39-.39H18a.39.39 0 00-.39.39v6.758h-1.563v-4.414a.39.39 0 00-.39-.391h-2.345a.39.39 0 00-.39.39v4.415H10.07V8.39a.39.39 0 00-.78 0v1.016h-.9a.39.39 0 000 .781h.9v1.563h-.9a.39.39 0 000 .781h.9v1.563h-.9a.39.39 0 000 .781h.9v1.563h-.9a.39.39 0 100 .78h.9v1.563h-.9a.39.39 0 000 .782h.9v1.562h-.9a.39.39 0 000 .781h.9v1.563h-.9a.39.39 0 000 .78h.9v1.68h-.9zm10-6.366h1.563v6.367h-1.562v-6.367zm-4.687 2.343h1.563v4.024h-1.563v-4.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.031 13.703a.39.39 0 00.39-.39v-2.345a.39.39 0 00-.39-.39h-2.343a.39.39 0 000 .781h1.4l-3.906 3.906H18a.39.39 0 00-.276.115l-3.516 3.515a.39.39 0 10.553.553l3.4-3.401h2.183a.391.391 0 00.276-.115l4.02-4.02v1.4c0 .216.175.39.391.39zM25.031 21.906a.39.39 0 100-.781.39.39 0 000 .781z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "led-annual-consumption_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgLedAnnualConsumption;